<template>
  <div>
    <div class="showcase-circle">
      <swiper v-if="images.length>0" :slides="images"></swiper>
    </div>
    <div class="product-name">{{ productData.ProductName }}</div>
    <div class="sub-product-name">{{ productData.SubProductName }}</div>
  </div>
</template>
<script>
  import swiper from '@/components/composite/swiper'
  export default {
    components: {swiper},
    props: {
      cardData: Object
    },
    data(){
      return {};
    },
    computed: {
      productData(){
        return this.cardData.productData || {};
      },
      images(){
        const {Thumbnail1, Thumbnail2, Thumbnail3, Thumbnail4, Thumbnail5} = this.productData;
        return [Thumbnail1, Thumbnail2, Thumbnail3, Thumbnail4, Thumbnail5].filter(thumb => thumb);
      }
    }
  }
</script>
<style rel="stylesheet/less" lang="less" scoped>
  .showcase-circle {
    position: relative;
    width: 5.2rem;
    height: 5.2rem;
    border-radius: 50%;
    z-index: 100;
    margin: 15% auto 0;
    border: 0.2rem solid #aa153d;
  }

  .product-name, .sub-product-name {
    text-align: center;
    color: #ffffff;
    margin-top: 0.2rem;
  }

  .product-name {
    font-size: 20px;
  }

  .sub-product-name {
    font-size: 16px;
  }
</style>



// WEBPACK FOOTER //
// swiper-card.vue?943c5cee